module.exports = __webpack_public_path__ + "assets/img/qr-ios.4ae5d284.png";